import {useState} from "react";
import className from "classnames/bind";
import style from "../style/Gsc.module.scss";

const cn = className.bind(style);

const LINE = '#7c3aed';

/**
 * Biểu đồ vị trí (thứ hạng) theo ngày cho MỘT từ khoá (SVG thuần). Trục Y **đảo**: vị trí
 * nhỏ (hạng tốt) ở TRÊN. Chỉ vẽ những ngày có dữ liệu. series: [{date, position, clicks, impressions}].
 */
function RankChart({series = []}) {

	const [hover, setHover] = useState(null);

	const pts = series.filter((d) => Number(d.position) > 0);

	if (pts.length === 0) {
		return <div className={cn('chartEmpty')}>Chưa có dữ liệu vị trí cho từ khoá này trong khoảng thời gian đã chọn.</div>;
	}

	const W = 720;
	const H = 220;
	const P = 30;
	const innerW = W - P * 2;
	const innerH = H - P * 2;

	const n = pts.length;
	const positions = pts.map((d) => Number(d.position));
	let minPos = Math.min(...positions);
	let maxPos = Math.max(...positions);
	if (maxPos === minPos) { maxPos += 1; minPos = Math.max(1, minPos - 1); } // tránh chia 0

	const x = (i) => (n === 1 ? W / 2 : P + (innerW * i) / (n - 1));
	// Đảo trục: vị trí nhỏ (tốt) → y nhỏ (trên).
	const y = (pos) => P + (innerH * (pos - minPos)) / (maxPos - minPos);

	const linePts = pts.map((d, i) => ({x: x(i), y: y(Number(d.position))}));
	const line = 'M ' + linePts.map((p) => `${p.x},${p.y}`).join(' L ');

	const ticks = n === 1 ? [0] : [0, Math.floor((n - 1) / 2), n - 1];
	const last = n - 1;

	const handleMove = (e) => {
		const rect = e.currentTarget.getBoundingClientRect();
		const frac = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
		setHover(n === 1 ? 0 : Math.round(frac * (n - 1)));
	};

	const hoverPct = hover === null ? 0 : (n === 1 ? 50 : (hover / (n - 1)) * 100);

	return (
		<div className={cn('chart')}>
			<div className={cn('legend')}>
				<span className={cn('legendItem')}><span className={cn('dot')} style={{background: LINE}} /> Vị trí trung bình (nhỏ hơn = tốt hơn)</span>
			</div>

			<div className={cn('plotWrap')} onMouseMove={handleMove} onMouseLeave={() => setHover(null)}>
				<svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
					{/* Lưới ngang + nhãn hạng tốt/kém */}
					{[0, 0.5, 1].map((g) => (
						<line key={g} x1={P} y1={P + innerH * g} x2={W - P} y2={P + innerH * g}
							stroke="#eef0f4" strokeWidth="1" vectorEffect="non-scaling-stroke" />
					))}
					<text x={4} y={P + 4} fontSize="10" fill="#9ca3af">#{Math.round(minPos)}</text>
					<text x={4} y={P + innerH} fontSize="10" fill="#9ca3af">#{Math.round(maxPos)}</text>

					{n > 1 && (
						<path d={line} fill="none" stroke={LINE} strokeWidth="2.5"
							strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
					)}

					{linePts.map((p, i) => (
						<circle key={i} cx={p.x} cy={p.y} r={hover === i ? 4.5 : (i === last ? 3.5 : 2.5)}
							fill="#fff" stroke={LINE} strokeWidth="2" vectorEffect="non-scaling-stroke" />
					))}

					{hover !== null && (
						<line x1={x(hover)} y1={P} x2={x(hover)} y2={P + innerH}
							stroke="#94a3b8" strokeWidth="1" strokeDasharray="4 3" vectorEffect="non-scaling-stroke" />
					)}

					{ticks.map((i) => (
						<text key={i} x={x(i)} y={H - 6} fontSize="10" fill="#9ca3af"
							textAnchor={i === 0 ? 'start' : i === n - 1 ? 'end' : 'middle'}>
							{String(pts[i].date).slice(5)}
						</text>
					))}
				</svg>

				{hover !== null && (
					<div className={cn('tooltip')} style={{left: `${hoverPct}%`}}>
						<div className={cn('tooltipDate')}>{pts[hover].date}</div>
						<div className={cn('tooltipRow')}><span>Vị trí</span><b>{Number(pts[hover].position).toFixed(1)}</b></div>
						<div className={cn('tooltipRow')}><span>Clicks</span><b>{pts[hover].clicks}</b></div>
						<div className={cn('tooltipRow')}><span>Impressions</span><b>{pts[hover].impressions}</b></div>
					</div>
				)}
			</div>
		</div>
	);
}

export default RankChart;
